
<template>
     <a-select show-search :value="value" placeholder="输入syscode"  allow-clear 
         :default-active-first-option="false" :show-arrow="false" :filter-option="false" :not-found-content="null"
         @search="handleSearch" @change="handleChange">
         <a-select-option v-for="d in data" :key="d.syscode">
             {{  ' 应用类型：' + d.apptype + '  系统编码：'+d.syscode }}
         </a-select-option>
     </a-select>
</template>
<script>

export default {
    data() {
        return {
            data: [],
            searchTimmer:null,
            value:''
        }
    },
    model:{
        event:'change'
    },
    props:{
        kaenv:{
            type:String,
            default:''
        },
    },
    mounted(){
        this.doSearch('')
    },

    methods: {
        init(syscode){
            this.value = syscode
            this.handleChange(this.value)
        },
        handleChange(value) {
            let result = this.data.filter(item => { return item.syscode == value})
            if(result.length > 0){
                this.$emit('handleSelect',result[0]);
                this.value = result[0].syscode

            }
        },
        handleSearch(value) {
            let that = this;
            if(that.searchTimmer){
                clearTimeout(that.searchTimmer)
                that.searchTimmer = null;
            }
            that.searchTimmer = setTimeout(() => {
                that.doSearch(value);
                that.searchTimmer = null;
            }, 500);
        },
        doSearch(value) {
            let that = this;
            let c_params = {
                kaenv:that.kaenv,
                keyword:value,
                urlparams:false,
            }

            that.$store.dispatch({
                type: "kamanager/queryrelatesys",
                params: c_params,
                showMsg: false
            }).then((res) => {
                if (res.data.success == 1) {
                    that.data = [];
                    let result = res.data.data;
                    if(!result){
                        return;
                    }
                    that.data = result;
                    if(that.value){
                        that.handleChange(that.value)
                    }
                }
            }).catch(() => {

            });
        },
    },
   
};
</script>

<style scoped>

</style>
